import { Rgba } from 'ngx-color-picker';
import { ChartConstants } from './chart/chart-constants';
import { ProjConstants } from './proj.constant';

export class Chartconstant {

  chartObjectRainfall: ChartConstants;
  chartObjectHumidity: ChartConstants;
  chartObjectTemperature: ChartConstants;
  chartObjectWindspeed: ChartConstants;
  chartObjectHeatwave: ChartConstants;
  chartObjectColdwave : ChartConstants;
  chartObjectHeatwatches: ChartConstants;
  chartObjectHeatindex: ChartConstants;
  chartObjectDiscomfortindex : ChartConstants;
  chartObjectRainfallEnsembleChart1: ChartConstants;
  chartObjectRainfallEnsembleChart2: ChartConstants;
  chartObjectRainfallWeekly: ChartConstants;
  chartObjectCyclone: ChartConstants;
  chartObjectRainfallActual: ChartConstants;
  chartObjectRainfallUnified: ChartConstants;
  chartObjectWindspeedUnified: ChartConstants;
  chartObjectNowcast: ChartConstants;
  chartObjectHourly: ChartConstants;
  chartObjectSeamlessrainfall: ChartConstants;

  PlotBandsForChart1 = {};
  PlotBandsForChart2 = {};

  constructor() {
    this.setChartRainfall();
    this.setChartHumidity();
    this.setChartTemperature();
    this.setChartWindSpeed();
    this.setChartHeatIndex();
    this.setChartHeatWatches();
    this.setChartHeatWave();
    this.setColdWave();
    this.setChartDiscomfortIndex();
    this.setChartRainfallEnsembleChart1();
    this.setChartRainfallEnsembleChart2();
    this.setChartRainfallWeeklyChart3();
    this.setPlotBandForChart1();
    this.setPlotBandForChart2();
    this.setChartCyclone();
    this.setRainfallActual();
    this.setChartRainfallUnified();
    this.setChartWindspeedUnified();
    this.setChartNowcast();
    this.setChartSeamlessRaifall();
    this.setChartHourly();
  }

  setChartRainfall() {

    this.chartObjectRainfall = new ChartConstants();

    this.chartObjectRainfall.colors = {
      'no rainfall': '#FFFFFF',
      'very light rainfall': '#C3FDCA',
      'light rainfall': '#01FF04',
      'moderate rainfall': '#048500',
      'heavy rainfall': '#FDC0CB',
      'very heavy rainfall': '#FC0300',
      'extremely heavy rainfall': '#610301'
    };
    this.chartObjectRainfall['yAxisTitle'] = 'Rainfall Band(mm)';
    this.chartObjectRainfall.chartType = 'column';
    this.chartObjectRainfall.plotOptions = {
      series: {
        pointWidth: 25
      },
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: false,
          color: 'white'
        }
      }
    };

    this.chartObjectRainfall.legend = {
      enabled: true
    };
    this.chartObjectRainfall.chartTitle = '';
    this.chartObjectRainfall.tooltips = {
      backgroundColor: '#FCFFC5',
      borderColor: 'black',
      borderRadius: 10,
      borderWidth: 3
    };

  }
  setChartNowcast() {

    this.chartObjectNowcast = new ChartConstants();

    this.chartObjectNowcast.colors = {
      'no rainfall': '#d3d8dc',
      '0.1 - 0.5': '#2740b9',
      '0.5 - 1.0': '#004aff',
      '1.0 - 2.0': '#11c3d9',
      '2.0 - 3.0': '#32e909',
      '3.0 - 5.0': '#b1f450',
      '5.0 - 10.0': '#fffb00',
      '10.0 - 15.0': '#f8b835',
      '15.0 - 20.0': '#fd7803',
      '20.0 - 25.0': '#ff0000',
      '>25.0': '#943131',
    };
    this.chartObjectNowcast['yAxisTitle'] = 'Rainfall Band(mm)';
    this.chartObjectNowcast.chartType = 'column';
    this.chartObjectNowcast.plotOptions = {
      series: {
        pointWidth: 25
      },
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: false,
          color: 'white'
        }
      }
    };

    this.chartObjectNowcast.legend = {
      enabled: true
    };
    this.chartObjectNowcast.chartTitle = '';
    this.chartObjectNowcast.tooltips = {
      backgroundColor: '#FCFFC5',
      borderColor: 'black',
      borderRadius: 10,
      borderWidth: 3
    };

  }

  setChartHourly() {

    this.chartObjectHourly = new ChartConstants();

    this.chartObjectHourly.colors = {
      'no rainfall': '#d3d8dc',
      'very light rainfall': '#2740b9',
      'light rainfall': '#004aff',
    };
    this.chartObjectHourly['yAxisTitle'] = 'Rainfall Band(mm)';
    this.chartObjectHourly.chartType = 'column';
    this.chartObjectHourly.plotOptions = {
      series: {
        pointWidth: 25
      },
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: false,
          color: 'white'
        }
      }
    };

    this.chartObjectHourly.legend = {
      enabled: true
    };
    this.chartObjectHourly.chartTitle = '';
    this.chartObjectHourly.tooltips = {
      backgroundColor: '#FCFFC5',
      borderColor: 'black',
      borderRadius: 10,
      borderWidth: 3
    };

  }

  setChartRainfallWeeklyChart3(){
    this.chartObjectRainfallWeekly = this.chartObjectRainfall;
  }

  setChartSeamlessRaifall(){
    this.chartObjectSeamlessrainfall = this.chartObjectRainfall;
  }

  // setChartRainfallWeeklyChart3() {
  //   this.chartObjectRainfallWeekly = new ChartConstants();

  //   this.chartObjectRainfallWeekly.colors = {
  //     'very light rainfall': '#FFFFFF',
  //     // 'very light rainfall': '#C3FDCA',
  //     'light rainfall': '#fbff99',
  //     'moderate rainfall': '#f8ff00',
  //     'heavy rainfall': '#2ab0ff',
  //     'very heavy rainfall': '#00743c',
  //     'extremely heavy rainfall': '#ff0000'
  //   };
  //   this.chartObjectRainfallWeekly['yAxisTitle'] = 'Rainfall Band(mm)';
  //   this.chartObjectRainfallWeekly.chartType = 'column';
  //   this.chartObjectRainfallWeekly.plotOptions = {
  //     series: {
  //       pointWidth: 25
  //     },
  //     column: {
  //       stacking: 'normal',
  //       dataLabels: {
  //         enabled: false,
  //         color: 'white'
  //       }
  //     }
  //   };

  //   this.chartObjectRainfallWeekly.legend = {
  //     enabled: true
  //   };
  //   this.chartObjectRainfallWeekly.chartTitle = '';
  //   this.chartObjectRainfallWeekly.tooltips = {
  //     backgroundColor: '#FCFFC5',
  //     borderColor: 'black',
  //     borderRadius: 10,
  //     borderWidth: 3
  //   };
  // }

  setChartRainfallUnified() {

    this.chartObjectRainfallUnified = new ChartConstants();
    this.chartObjectRainfallUnified.colors = {
      'no rainfall': '#FFFFFF',
      'very light rainfall': '#C3FDCA',
      'light rainfall': '#01FF04',
      'moderate rainfall': '#048500',
      'heavy rainfall': '#FDC0CB',
      'very heavy rainfall': '#FC0300',
      'extremely heavy rainfall': '#610301'
    };
    this.chartObjectRainfallUnified['yAxisTitle'] = 'Rainfall Band(mm)';
    this.chartObjectRainfallUnified.chartType = 'donut';
    this.chartObjectRainfallUnified.plotOptions = {
      pie: {
        innerSize: '60%',
        dataLabels: {
          enabled: false,
          color: 'white',
        }
      }
    };

    this.chartObjectRainfallUnified.legend = {
      enabled: true
    };
    this.chartObjectRainfallUnified.chartTitle = '';
    this.chartObjectRainfallUnified.tooltips = {
      backgroundColor: '#FCFFC5',
      borderColor: 'black',
      borderRadius: 10,
      borderWidth: 3,
      valueSuffix: '%'
    };

  }

  setChartHumidity() {

    this.chartObjectHumidity = new ChartConstants();
    this.chartObjectHumidity.colors = {
      'no humidity': '#2944BE',
      'very light humidity': '#167D9C',
      'light humidity': '#63B86C',
      'moderate humidity': '#E9CB2E',
      'heavy humidity': '#FF9507',
      'very heavy humidity': '#FF6C0D',
      'extremely heavy humidity': '#F7340A'
    };

    this.chartObjectHumidity['yAxisTitle'] = 'Humidity Band (%)';
    this.chartObjectHumidity.chartType = 'column';
    this.chartObjectHumidity.plotOptions = {
      series: {
        pointWidth: 25
      },
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: false,
          color: 'white'
        }
      }
    };

    this.chartObjectHumidity.legend = {
      enabled: true
    };
    this.chartObjectHumidity.chartTitle = '';
    this.chartObjectHumidity.tooltips = {
      backgroundColor: '#FCFFC5',
      borderColor: 'black',
      borderRadius: 10,
      borderWidth: 3
    };

  }

  setChartTemperature() {

    this.chartObjectTemperature = new ChartConstants();
    this.chartObjectTemperature.colors = {
      '<0': '#00167B',
      '0-5': '#001B95',
      '5-10': '#0C41BB',
      '10-15': '#1265A9',
      '15-20': '#188E93',
      '20-25': '#81BA63',
      '25-28': '#CCC24F',
      '28-31': '#FFBB38',
      '31-34': '#FF9E20',
      '34-37': '#FF800E',
      '37-40': '#FD5F0D',
      '40-43': '#FF3F0A',
      '43-46': '#DF2108',
      '>=46': '#AD1919'
    };
    this.chartObjectTemperature['yAxisTitle'] = 'Temperature Band (°C)';
    this.chartObjectTemperature.chartType = 'column';
    this.chartObjectTemperature.plotOptions = {
      series: {
        pointWidth: 25
      },
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: false,
          color: 'white'
        }
      }
    };

    this.chartObjectTemperature.legend = {
      enabled: true
    };
    this.chartObjectTemperature.chartTitle = '';
    this.chartObjectTemperature.tooltips = {
      backgroundColor: '#FCFFC5',
      borderColor: 'black',
      borderRadius: 10,
      borderWidth: 3
    };

  }

  setChartWindSpeed() {
    //   0-5': {
    //     'background-color': '#2F2CE0'
    // },
    // '5-12': {
    //     'background-color': '#007BFF'
    // },
    // '12-17': {
    //     'background-color': '#1DBEC6'
    // },
    // '17-24': {
    //     'background-color': '#068556'
    // },
    // '24-30': {
    //     'background-color': '#039603'
    // },
    // '30-37': {
    //     'background-color': '#53D304'
    // },
    // '37-45': {
    //     'background-color': '#E0C900'
    // },
    // '45-60': {
    //     'background-color': '#C4032D'
    // },
    // '60-80': {
    //     'background-color': '#7A583F'
    // },
    // '80-103': {
    //     'background-color': '#795548'
    // },
    // '>=103': {
    //     'background-color': '#9A5F58'
    // }
    // },
    this.chartObjectWindspeed = new ChartConstants();
    this.chartObjectWindspeed.colors = {
      '0-5': '#4986c0',
      '5-10': '#4b90c6',
      '10-20': '#41acc4',
      '20-30': '#3eb7c2',
      '30-40': '#43cba2',
      '40-50': '#50d673',
      '50-60': '#a6d44f',
      '60-70': '#d1cd49',
      '70-80': '#e66d41',
      '80-100': '#e64f3e',
      '100-120': '#db3834',
      '120-160': '#d3292d',
      '>=160': '#c40f20',
    };
    this.chartObjectTemperature['yAxisTitle'] = 'Temperature Band (°C)';
    this.chartObjectWindspeed.chartType = 'column';
    this.chartObjectWindspeed.plotOptions = {
      series: {
        pointWidth: 25
      },
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: false,
          color: 'white'
        }
      }
    };

    this.chartObjectWindspeed.legend = {
      enabled: true
    };
    this.chartObjectWindspeed.chartTitle = '';
    this.chartObjectWindspeed.tooltips = {
      backgroundColor: '#FCFFC5',
      borderColor: 'black',
      borderRadius: 10,
      borderWidth: 3
    };
  }

  setChartWindspeedUnified() {
    this.chartObjectWindspeedUnified = new ChartConstants();
    this.chartObjectWindspeedUnified.colors = {
      '0-5': '#4986c0',
      '5-10': '#4b90c6',
      '10-20': '#41acc4',
      '20-30': '#3eb7c2',
      '30-40': '#43cba2',
      '40-50': '#50d673',
      '50-60': '#a6d44f',
      '60-70': '#d1cd49',
      '70-80': '#e66d41',
      '80-100': '#e64f3e',
      '100-120': '#db3834',
      '120-160': '#d3292d',
      '>=160': '#c40f20',
    };
    // this.chartObjectTemperature['yAxisTitle'] = 'Temperature Band (°C)';
    this.chartObjectWindspeedUnified.chartType = 'donut';
    this.chartObjectWindspeedUnified.plotOptions = {
      pie: {
        innerSize: '60%',
        dataLabels: {
          enabled: false,
          color: 'white',
        }
      }
    };

    this.chartObjectWindspeedUnified.legend = {
      enabled: true
    };
    this.chartObjectWindspeedUnified.chartTitle = '';
    this.chartObjectWindspeedUnified.tooltips = {
      backgroundColor: '#FCFFC5',
      borderColor: 'black',
      borderRadius: 10,
      borderWidth: 3,
      valueSuffix: '%'
    };
  }

  setChartHeatWave() {

    this.chartObjectHeatwave = new ChartConstants();

    this.chartObjectHeatwave.colors = ProjConstants.HEATWAVE_LEGEND_CHART;

    this.chartObjectHeatwave.chartType = 'column';
    this.chartObjectHeatwave.plotOptions = {
      series: {
        pointWidth: 25
      },
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: false,
          color: 'white'
        }
      }
    };
    this.chartObjectHeatwave['yAxisTitle'] = 'Temperature Band (°C)';
    this.chartObjectHeatwave.legend = {
      enabled: true
    };
    this.chartObjectHeatwave.chartTitle = '';
    this.chartObjectHeatwave.tooltips = {
      backgroundColor: '#FCFFC5',
      borderColor: 'black',
      borderRadius: 10,
      borderWidth: 3
    };

  }
  setColdWave() {

    this.chartObjectColdwave = new ChartConstants();

    this.chartObjectColdwave.colors = ProjConstants.COLD_WATCHES_LEGEND_CHART;

    this.chartObjectColdwave.chartType = 'column';
    this.chartObjectColdwave.plotOptions = {
      series: {
        pointWidth: 25
      },
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: false,
          color: 'white'
        }
      }
    };
    this.chartObjectColdwave['yAxisTitle'] = 'Temperature Band (°C)';
    this.chartObjectColdwave.legend = {
      enabled: true
    };
    this.chartObjectColdwave.chartTitle = '';
    this.chartObjectColdwave.tooltips = {
      backgroundColor: '#FCFFC5',
      borderColor: 'black',
      borderRadius: 10,
      borderWidth: 3
    };

  }

  setChartHeatWatches() {

    this.chartObjectHeatwatches = new ChartConstants();

    this.chartObjectHeatwatches.colors = ProjConstants.HEAT_WATCHES_LEGEND;
    this.chartObjectHeatwatches['yAxisTitle'] = 'Heat Watches Band ';
    this.chartObjectHeatwatches.chartType = 'column';
    this.chartObjectHeatwatches.plotOptions = {
      series: {
        pointWidth: 25
      },
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: false,
          color: 'white'
        }
      }
    };

    this.chartObjectHeatwatches.legend = {
      enabled: true
    };
    this.chartObjectHeatwatches.chartTitle = '';
    this.chartObjectHeatwatches.tooltips = {
      backgroundColor: '#FCFFC5',
      borderColor: 'black',
      borderRadius: 10,
      borderWidth: 3
    };

  }

  setChartHeatIndex() {

    this.chartObjectHeatindex = new ChartConstants();

    this.chartObjectHeatindex.colors = ProjConstants.HEAT_INDEX_LEGEND_CHART;

    this.chartObjectHeatindex.chartType = 'column';
    this.chartObjectHeatindex.plotOptions = {
      series: {
        pointWidth: 25
      },
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: false,
          color: 'white'
        }
      }
    };
    this.chartObjectHeatindex['yAxisTitle'] = 'Heat Index Band';
    this.chartObjectHeatindex.legend = {
      enabled: true
    };
    this.chartObjectHeatindex.chartTitle = '';
    this.chartObjectHeatindex.tooltips = {
      backgroundColor: '#FCFFC5',
      borderColor: 'black',
      borderRadius: 10,
      borderWidth: 3
    };

  }

  setChartDiscomfortIndex(){
    this.chartObjectDiscomfortindex = new ChartConstants();

    this.chartObjectDiscomfortindex.colors = ProjConstants.DISCOMFORT_INDEX_LEGEND;

    this.chartObjectDiscomfortindex.chartType = 'column';
    this.chartObjectDiscomfortindex.plotOptions = {
      series: {
        pointWidth: 25
      },
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: false,
          color: 'white'
        }
      }
    };
    this.chartObjectDiscomfortindex['yAxisTitle'] = 'Discomfort Index Band';
    this.chartObjectDiscomfortindex.legend = {
      enabled: true
    };
    this.chartObjectDiscomfortindex.chartTitle = '';
    this.chartObjectDiscomfortindex.tooltips = {
      backgroundColor: '#FCFFC5',
      borderColor: 'black',
      borderRadius: 10,
      borderWidth: 3
    };
  }

  setChartRainfallEnsembleChart1() {
    this.chartObjectRainfallEnsembleChart1 = new ChartConstants();
    this.chartObjectRainfallEnsembleChart1.chartType = 'boxplot';
    this.chartObjectRainfallEnsembleChart1.plotOptions = {
      series: {
        name: 'Rainfall Area Average'
      }
    };
    this.chartObjectRainfallEnsembleChart1.yAxisTitle = 'Area Average Rainfall(mm)';
    this.chartObjectRainfallEnsembleChart1.legend = {
      enabled: true
    };
    this.chartObjectRainfallEnsembleChart1.chartTitle = 'District wise Rainfall (Area average in \'mm\')';
  }

  setChartRainfallEnsembleChart2() {
    this.chartObjectRainfallEnsembleChart2 = new ChartConstants();
    this.chartObjectRainfallEnsembleChart2.chartType = 'boxplot';
    this.chartObjectRainfallEnsembleChart2.plotOptions = {
      series: {
        name: 'Rainfall Area Coverage'
      }
    };
    this.chartObjectRainfallEnsembleChart2.yAxisTitle = 'Area Average Rainfall(%)';
    this.chartObjectRainfallEnsembleChart2.legend = {
      enabled: true
    };
    this.chartObjectRainfallEnsembleChart2.chartTitle = 'District wise area coverage (in %) of Rainfall (2.5mm and above)';
  }

  setPlotBandForChart1() {
    this.PlotBandsForChart1 = {
      'Very Light Rainfall': {
        from: Number.MIN_SAFE_INTEGER,
        to: 2.5,
        color: 'rgba(255, 255, 255, 0.5)'
      },
      'Light Rainfall': {
        from: 2.5,
        to: 15.6,
        color: 'rgba(0, 255, 0, 0.5)'
      },
      'Moderate Rainfall': {
        from: 15.6,
        to: 64.5,
        color: 'rgba(0, 77, 0, 0.5)'
      },
      'Heavy Rainfall': {
        from: 64.5,
        to: 115.6,
        color: 'rgba(240, 199, 199, 0.5)'
      },
      'Very Heavy Rainfall': {
        from: 115.6,
        to: 500.0,
        color: 'rgba(255, 0, 0, 0.5)'
      }
    };
  }

  setPlotBandForChart2() {
    this.PlotBandsForChart2 = {
      Isolated: {
        from: Number.MIN_SAFE_INTEGER,
        to: 25,
        color: 'rgba(0, 255, 0, 0.2)'
      },
      Scattered: {
        from: 25,
        to: 50,
        color: 'rgba(0, 255, 0, 0.5)'
      },
      'Fairly widespread': {
        from: 50,
        to: 75,
        color: 'rgba(0, 0, 204, 0.5)'
      },
      Widespread: {
        from: 75,
        to: Number.MAX_SAFE_INTEGER,
        color: 'rgba(155, 0, 0, 0.5)'
      }
    };
  }

  setChartCyclone() {

    this.chartObjectCyclone = new ChartConstants();
    this.chartObjectCyclone.colors = {
      L: '#f3f3f3',
      D: '#00faf4',
      DD: '#4a86e8',
      CS: '#1c4587',
      SCS: '#fbbc04',
      VSCS: '#ff6d01',
      ESCS: '#ff0000',
      SuCS: '#990000'
    };

    this.chartObjectCyclone['yAxisTitle'] = 'Probability (%)';
    this.chartObjectCyclone.chartType = 'column';
    this.chartObjectCyclone.stacking = 'percent';
    this.chartObjectCyclone.plotOptions = {
      series: {
        pointWidth: 20
      },
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: false,
          color: 'white'
        }
      }
    };

    this.chartObjectCyclone.legend = {
      enabled: true
    };
    this.chartObjectCyclone.chartTitle = 'Probability (%) of Cyclone Intensity';
    this.chartObjectCyclone.tooltips = {
      backgroundColor: '#FCFFC5',
      borderColor: 'black',
      borderRadius: 10,
      borderWidth: 3
    };

  }

  setRainfallActual() {
    this.chartObjectRainfallActual = new ChartConstants();
    this.chartObjectRainfallActual['yAxisTitle'] = 'Rainfall in mm';
    this.chartObjectRainfallActual.chartTitle = 'Actual Rainfall';
    this.chartObjectRainfallActual.chartType = 'column-bar';
    this.chartObjectRainfallActual.plotOptions = {
      series: {
        pointWidth: 8
      },
      column: {
        dataLabels: {
          enabled: false,
          color: 'white'
        }
      }
    };
  }
}
